import { Link } from "react-router-dom";

import { BrandMark } from "./brand-mark";

export function SiteHeader() {
  return (
    <header className="site-header">
      <div className="shell site-header__inner">
        <Link className="brand" to="/" aria-label="Bye Now home">
          <BrandMark />
          <span>Bye Now</span>
        </Link>
        <nav aria-label="Primary navigation">
          <Link className="nav-link" to="/auth/sign-in">
            Sign in
          </Link>
        </nav>
      </div>
    </header>
  );
}
